import { ShirtspaceResponseMessage } from "@services/shirtspace.types";
import FlashMessage from "~/components/FlashMessage";

const ErrorMessage: React.FC<{
  error?: ShirtspaceResponseMessage;
}> = ({ error }) => {
  if (!error) return null;
  return (
    <div className="mt-[-1rem]">
      <FlashMessage
        kind="failure"
        message={error.text}
      />
    </div>
  );
};

export default ErrorMessage;
